export default "__VITE_PUBLIC_ASSET__2b47ff9b__"